@if (field) {
  <div class="modal fade" id="edit-organization-details-modal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit</h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" [hidden]="field !== 'notes'">
          <label>Notes</label>
          <textarea class="form-control" name="notes" [(ngModel)]="organization.notes" rows="5" placeholder="Notes"></textarea>
        </div>
        <div class="modal-body" [hidden]="field !== 'socials'">
          <form #editOrganizationSocialsForm="ngForm">
            <div class="form-group">
              <label>X</label>
              <input class="form-control" type="text" [ngClass]="setClassInvalidTpl(twitter)" #twitter="ngModel"
                [(ngModel)]="organization.socials.twitter.username" name="twitter" [pattern]="usernameRegexp.twitter" placeholder="mario_rossi">
            </div>
            <div class="form-group">
              <label>Instagram</label>
              <input class="form-control" type="text" [ngClass]="setClassInvalidTpl(instagram)" #instagram="ngModel"
                [(ngModel)]="organization.socials.instagram.username" name="instagram" [pattern]="usernameRegexp.instagram" placeholder="mario.rossi">
            </div>
            <div class="form-group">
              <label>Facebook</label>
              <input class="form-control" type="text" [ngClass]="setClassInvalidTpl(facebook)" #facebook="ngModel"
                [(ngModel)]="organization.socials.facebook.username" name="facebook" [pattern]="usernameRegexp.facebook" placeholder="MarioRossiOfficial">
            </div>
            <div class="form-group">
              <label>LinkedIn</label>
              <input class="form-control" type="text" [ngClass]="setClassInvalidTpl(linkedin)" #linkedin="ngModel"
                [(ngModel)]="organization.socials.linkedin.username" name="linkedin" [pattern]="usernameRegexp.linkedin" placeholder="mario-rossi">
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
            [disabled]="(field === 'socials' && !editOrganizationSocialsForm.form.valid)"
            (click)="updateOrganization(field)">
            <i class="fa fa-floppy-o"></i> Save
          </button>
        </div>
      </div>
    </div>
  </div>
}